import { FloatButton, message } from 'antd';
import 'antd/dist/reset.css';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import React, { Fragment, useEffect, useState } from 'react';
//translation
import { I18nextProvider, initReactI18next } from 'react-i18next';
//redux
import { Provider } from 'react-redux';
//route
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
// antd. 5.0
import 'react-toastify/dist/ReactToastify.css';

import { checkProfile } from '@/controller/auth';
import { getTenant, isConfigurationCompleted } from '@/controller/configuration.js';
import CustomBackend from '@/controller/i18n/CustomBackend.js';
import setAuth from '@/redux/actions/authAction';
import { toast } from '@/shared/components/UI/Toast';
import { AUTH_KEYS, getAuthToken, isAuthenticated, setupAuthListeners } from '@/shared/utils/authStorage';
import { config as i18nextConfig } from '@/translations';

import Error503Page from '../pages/Error/Error503Page';
//scss / design
import '../scss/app.scss';
//other
import LoadingPage from './LoadingPage';
import Router from './Router';
import store from './store';

if (import.meta.env.VITE_APP_ENV === 'prod') {
    // ReactGA.initialize('G-8X4W9LC4J4');
}

message.config({
    maxCount: 4,
});

const App = () => {
    const [isDone, setDone] = useState(false);
    const [isMaintain, setMaintain] = useState(false);

    const { dispatch } = store;
    //componentDidMount

    useEffect(() => {
        const checkAdmin = async () => {
            try {
                const ret = await checkProfile();
                if (ret.status === 200 && ret.data.data.message) {
                    dispatch(setAuth(true));
                    setDone(true);
                } else {
                    // Clear auth tokens on failed check
                    localStorage.removeItem(AUTH_KEYS.ACCESS_TOKEN);
                    localStorage.removeItem(AUTH_KEYS.UUID);
                    toast.warning('Session Expired - Please Re-login');
                    setDone(true);
                }
            } catch (e) {
                console.error('Auth check failed:', e);
                setDone(true);
            }
        };

        // Setup cross-tab authentication listeners
        const cleanupListeners = setupAuthListeners(dispatch, setAuth);

        const bootstrapApp = async () => {
            setMaintain(false);

            try {
                // Parallelize tenant and configuration checks
                const [tenantResp, configResp] = await Promise.all([
                    getTenant(window.location.hostname),
                    isConfigurationCompleted(),
                ]);

                if (tenantResp.success) {
                    localStorage.setItem('tenants_id', tenantResp.data.id);
                    document.title = tenantResp.data.name;

                    // Initialize i18n
                    i18n.use(LanguageDetector).use(CustomBackend).use(initReactI18next).init(i18nextConfig);

                    if (configResp.success) {
                        const accessToken = getAuthToken(AUTH_KEYS.ACCESS_TOKEN);
                        if (accessToken) {
                            // Check if token is still valid
                            if (isAuthenticated()) {
                                await checkAdmin();
                            } else {
                                // Clear any remaining auth tokens
                                localStorage.removeItem(AUTH_KEYS.ACCESS_TOKEN);
                                localStorage.removeItem(AUTH_KEYS.UUID);
                                setDone(true);
                            }
                        } else {
                            // Clear any remaining auth tokens
                            localStorage.removeItem(AUTH_KEYS.ACCESS_TOKEN);
                            localStorage.removeItem(AUTH_KEYS.UUID);
                            setDone(true);
                        }
                    } else {
                        setMaintain(true);
                    }
                } else {
                    setMaintain(true);
                }
            } catch (error) {
                console.error('App bootstrap failed:', error);
                setMaintain(true);
            }
        };

        bootstrapApp();

        // Cleanup function
        return () => {
            cleanupListeners();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    return (
        <Provider store={store}>
            <BrowserRouter>
                <Fragment>
                    <I18nextProvider i18n={i18n}>
                        {/* <ConfigProvider theme={{ hashed: false }}> */}
                        <FloatButton.BackTop />
                        <ToastContainer className="toast__root" />
                        {isMaintain ? <Error503Page /> : isDone ? <Router /> : <LoadingPage />}
                        {/* </ConfigProvider> */}
                    </I18nextProvider>
                </Fragment>
            </BrowserRouter>
        </Provider>
    );
};

export default App;
